const consoleError = console.error;

console.error = (msg, ...args) => {
  if (
    msg &&
    typeof msg === 'string' &&
    msg.includes('Support for defaultProps')
  ) {
    // NOTE: Uber stopped publishing updates to baseweb. We have no easy way
    //       to fix this warning for basweb components that trigger this error.
    if (
      args &&
      Array.isArray(args) &&
      args.length > 0 &&
      [
        'Card',
        'MaskedInput',
        'MenuStatefulContainer2',
        'Popover2',
        'StatefulPopover',
        'StatefulTooltip',
      ].includes(args[0])
    ) {
      return;
    }
  }

  consoleError(msg, ...args);
};
